import * as PRTNR from "./prtnr";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import GenericModal from "./GenericModal";
import ModalAdmineditmember from "./ModalAdmineditmember";
import ModalAdminmemberstatus from "./ModalAdminmemberstatus";
import ModalAdminmemberstwo from "./ModalAdminmemberstwo";
import ModalUpdateSuccess from "./Modalupdatesuccess";
import Navbar from "./Navbar";
import PayoutModal from "./PayoutModal";
import {
  fetchAccountHistoryItem,
  fetchMemberById,
} from "./redux/slices/MembersThunks";
import { fetchOnboardingReferralsByID } from "./redux/slices/onboardingReferralsSlice";
import { fetchReferralByMemberId } from "./redux/slices/ReferralsThunks";
import { fetchWalletBalance } from "./redux/slices/WalletSlice";

const tableHeadersFriendsReferred = [
  { label: "Friend Name", flex: 1 },
  { label: "Friend Email", flex: 1 },
  { label: "Reward", flex: 1 },
  { label: "Status", flex: 1 },
];

const tableColumnsFriendsReferred = [
  { key: "friend_name", flex: 1 },
  { key: "friend_email", flex: 1 },
  { key: "reward", flex: 1 },
  { key: "reward_status", flex: 1 },
];

const formatDate = (isoDateStr) => {
  const date = new Date(isoDateStr);

  const day = date.getDate(); // Day of the month
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
const tableHeaders = [
  { label: "Referral ID", flex: true },
  { label: "Date", flex: true },
  { label: "Potential Client's Website", flex: true },
  { label: "Vendor", flex: true },
  { label: "Status", flex: true },
  { label: "Reward", flex: true, align: "flex-end" },
  { label: "Action", flex: true, align: "center" },
];

const tableColumns = [
  { key: "referral_id", flex: true },
  { key: "date", flex: true },
  { key: "company_website_url", flex: true },
  { key: "vendor_name", flex: true },
  { key: "referral_status", flex: true },
  { key: "vendor_reward", flex: true, align: "flex-end" },
  { key: "action", flex: true, align: "center" },
];

export default function Adminmemberstwo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [memberState, setMemberState] = useState(null);
  const { balance } = useSelector((state) => state.wallet);
  const { list } = useSelector((state) => state.onboardingReferrals);
  const [editMemberState, setEditMemberState] = useState(null);
  const [history, setHistory] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [openPayoutModal, setOpenPayoutModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const openSuccessModal = () => setIsSuccessModalOpen(true);
  const closeSuccessModal = () => setIsSuccessModalOpen(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    getHistory();
    setIsModalOpen(false);
  };
  const openEditModal = () => setIsEditModalOpen(true);
  const closeEditModal = () => {
    getHistory();
    setIsEditModalOpen(false);
  };
  const openStatusModal = () => setIsStatusModalOpen(true);
  const closeStatusModal = () => {
    getHistory();
    setIsStatusModalOpen(false);
  };

  const fetchMemberData = async () => {
    try {
      setLoading(true);
      const result = await dispatch(fetchMemberById(id));
      if (result.payload) {
        setMemberState(result.payload);
        setEditMemberState(result.payload);
      }
    } catch (error) {
      console.error("Error fetching member:", error);
    } finally {
      setLoading(false);
    }
  };

  const getHistory = async () => {
    if (!memberState) return;
    const res = await dispatch(
      fetchAccountHistoryItem(memberState.account_id?._id)
    );
    if (res.payload?.length > 0) {
      setHistory(res.payload);
    }
  };
  const handleClick = (item) => {
    navigate(`/adminreferralsone/${item._id}`);
  };
  const getReferrals = async () => {
    if (!memberState) return;
    const res = await dispatch(fetchReferralByMemberId(memberState._id));
    const data =
      res.payload?.data.length > 0
        ? res.payload.data.map((val) => {
            const status = val.referral_member_status;
            return {
              _id: val._id,
              referral_id: "R" + val._id.slice(-7),
              date: val?.created_at ? formatDate(val?.created_at) : "",
              referral_status: status || "",
              company_website_url: val?.company_website_url || " ",
              vendor_name: val.vendor_id?.company_name || " ",
              vendor_reward:
                val?.reward !== undefined
                  ? "£" + Number(val.reward)?.toLocaleString("en-GB")
                  : "-",
              dispute: val?.dispute
                ? {
                    _id: val.dispute._id,
                    dispute_status: val.dispute.dispute_status,
                    explanation: val.dispute.explanation,
                    created_at: formatDate(val.dispute.date_raised),
                  }
                : null,
            };
          })
        : [];
    setTableData(data);
  };

  useEffect(() => {
    if (id) {
      fetchMemberData();
    }
  }, [id]);

  useEffect(() => {
    if (memberState) {
      getHistory();
      getReferrals();
      dispatch(fetchWalletBalance(memberState._id));
      dispatch(fetchOnboardingReferralsByID(memberState._id));
    }
  }, [memberState, dispatch]);

  return (
    <RootWrapperAdminmemberstwo>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          {loading || !memberState ? (
            <div>Loading...</div>
          ) : (
            <Right>
              <Frame1577>
                <DashboardHeader>
                  <Frame1462>
                    <LinkButton
                      onClick={() => {
                        navigate(-1);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.21875 7.5625C0.0625 7.40625 0 7.21875 0 7C0 6.8125 0.0625 6.625 0.21875 6.46875L5.71875 1.21875C6.03125 0.9375 6.5 0.9375 6.78125 1.25C7.0625 1.53125 7.0625 2.03125 6.75 2.3125L2.59375 6.25H13.25C13.6562 6.25 14 6.59375 14 7C14 7.4375 13.6562 7.75 13.25 7.75H2.59375L6.75 11.7188C7.0625 12 7.0625 12.4688 6.78125 12.7812C6.5 13.0938 6.03125 13.0938 5.71875 12.8125L0.21875 7.5625Z"
                          fill="#64748B"
                        />
                      </svg>
                      <GetStarted>Back</GetStarted>
                    </LinkButton>
                    <WelcomeJames>{memberState?.email_address}</WelcomeJames>
                  </Frame1462>
                  <Widthdraw>
                    <Frame1422>
                      <Frame1429>
                        <Status>Status:</Status>
                        <LinkButton>
                          <BackContainer
                            onClick={() => {
                              openStatusModal();
                            }}
                          >
                            <ActiveText>
                              {memberState?.profile_status}
                            </ActiveText>
                            <svg
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.03881 11.2656C3.13699 11.0103 3.18609 10.8826 3.27029 10.8242C3.34388 10.7731 3.43493 10.7538 3.52293 10.7706C3.62362 10.7898 3.72032 10.8865 3.91372 11.0799L5.41978 12.586C5.61318 12.7794 5.70988 12.8761 5.72911 12.9767C5.74591 13.0647 5.72659 13.1558 5.67549 13.2294C5.61703 13.3136 5.48939 13.3627 5.23411 13.4609L1.66675 14.8329L3.03881 11.2656Z"
                                stroke="#3B5A6F"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M3.08964 11.1334C3.18065 10.8967 3.22615 10.7784 3.28557 10.6677C3.33835 10.5694 3.39926 10.4757 3.46768 10.3875C3.5447 10.2883 3.63433 10.1986 3.8136 10.0194L11.3334 2.49955C12.0698 1.76317 13.2637 1.76317 14.0001 2.49955C14.7365 3.23593 14.7365 4.42984 14.0001 5.16622L6.48027 12.686C6.301 12.8653 6.21136 12.9549 6.11211 13.032C6.02395 13.1004 5.93022 13.1613 5.83189 13.2141C5.7212 13.2735 5.60289 13.319 5.36626 13.41L1.66675 14.8329L3.08964 11.1334Z"
                                stroke="#6162C5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </BackContainer>
                        </LinkButton>
                      </Frame1429>
                      <Frame1429>
                        <Status>Current Balance: </Status>
                        {balance === null ? (
                          <ActiveText>No balance available</ActiveText>
                        ) : (
                          <ActiveText>£{balance}</ActiveText>
                        )}
                      </Frame1429>
                      <Frame1429>
                        <PRTNR.Button
                          onClick={() => setOpenPayoutModal(true)}
                          variant="black"
                          disabled={
                            balance === 0 ||
                            balance === null ||
                            (memberState?.member_type !== "Enterprise" &&
                              memberState?.stripe_account_id === null)
                          }
                          size="small"
                        >
                          Payout
                        </PRTNR.Button>
                      </Frame1429>
                    </Frame1422>
                  </Widthdraw>
                </DashboardHeader>
                <Enterprise>{memberState?.member_type}</Enterprise>
              </Frame1577>
              <Frame1469>
                <Frame1507>
                  <ProfilePic>
                    {memberState?.account_id?.profile_picture && (
                      <img
                        src={`${memberState?.account_id?.profile_picture}`}
                        alt="Profile"
                        style={{
                          width: "142px",
                          height: "142px",
                          borderRadius: "500px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </ProfilePic>
                  <LinkButton style={{ marginTop: "10px" }}>
                    <BackContainer
                      onClick={() => {
                        openModal();
                      }}
                    >
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.03881 11.2656C3.13699 11.0103 3.18609 10.8826 3.27029 10.8242C3.34388 10.7731 3.43493 10.7538 3.52293 10.7706C3.62362 10.7898 3.72032 10.8865 3.91372 11.0799L5.41978 12.586C5.61318 12.7794 5.70988 12.8761 5.72911 12.9767C5.74591 13.0647 5.72659 13.1558 5.67549 13.2294C5.61703 13.3136 5.48939 13.3627 5.23411 13.4609L1.66675 14.8329L3.03881 11.2656Z"
                          stroke="#3B5A6F"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.08964 11.1334C3.18065 10.8967 3.22615 10.7784 3.28557 10.6677C3.33835 10.5694 3.39926 10.4757 3.46768 10.3875C3.5447 10.2883 3.63433 10.1986 3.8136 10.0194L11.3334 2.49955C12.0698 1.76317 13.2637 1.76317 14.0001 2.49955C14.7365 3.23593 14.7365 4.42984 14.0001 5.16622L6.48027 12.686C6.301 12.8653 6.21136 12.9549 6.11211 13.032C6.02395 13.1004 5.93022 13.1613 5.83189 13.2141C5.7212 13.2735 5.60289 13.319 5.36626 13.41L1.66675 14.8329L3.08964 11.1334Z"
                          stroke="#6162C5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <ActiveText style={{ marginLeft: 0 }}>
                        Edit picture
                      </ActiveText>
                    </BackContainer>
                  </LinkButton>
                </Frame1507>
                <Frame1511>
                  <Frame1484>
                    <ProfileDetails>Profile Details</ProfileDetails>
                    <LinkButton>
                      <BackContainer
                        onClick={() => {
                          openEditModal();
                        }}
                      >
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.03881 11.2656C3.13699 11.0103 3.18609 10.8826 3.27029 10.8242C3.34388 10.7731 3.43493 10.7538 3.52293 10.7706C3.62362 10.7898 3.72032 10.8865 3.91372 11.0799L5.41978 12.586C5.61318 12.7794 5.70988 12.8761 5.72911 12.9767C5.74591 13.0647 5.72659 13.1558 5.67549 13.2294C5.61703 13.3136 5.48939 13.3627 5.23411 13.4609L1.66675 14.8329L3.03881 11.2656Z"
                            stroke="#3B5A6F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.08964 11.1334C3.18065 10.8967 3.22615 10.7784 3.28557 10.6677C3.33835 10.5694 3.39926 10.4757 3.46768 10.3875C3.5447 10.2883 3.63433 10.1986 3.8136 10.0194L11.3334 2.49955C12.0698 1.76317 13.2637 1.76317 14.0001 2.49955C14.7365 3.23593 14.7365 4.42984 14.0001 5.16622L6.48027 12.686C6.301 12.8653 6.21136 12.9549 6.11211 13.032C6.02395 13.1004 5.93022 13.1613 5.83189 13.2141C5.7212 13.2735 5.60289 13.319 5.36626 13.41L1.66675 14.8329L3.08964 11.1334Z"
                            stroke="#6162C5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <ActiveText style={{ marginLeft: 0 }}>
                          Edit details
                        </ActiveText>
                      </BackContainer>
                    </LinkButton>
                  </Frame1484>

                  <Frame1508>
                    <Frame1510>
                      <Frame1485>
                        <Frame1470>
                          <Frame1577>
                            <FirstName>First Name</FirstName>
                            <James>{memberState.first_name}</James>
                          </Frame1577>
                          <Frame1577>
                            <FirstName>Email Address</FirstName>
                            <JamesDoeEmailCom>
                              {memberState.email_address}
                            </JamesDoeEmailCom>
                          </Frame1577>
                          {memberState?.member_type === "Enterprise" && (
                            <Frame1577>
                              <CompanyName>Company Name</CompanyName>
                              <GreenLeafSolutions>
                                {memberState?.company_name}
                              </GreenLeafSolutions>
                            </Frame1577>
                          )}
                          <Frame1577>
                            <JobTitle>Job Title</JobTitle>
                            <ProductManager>
                              {memberState?.job_title}
                            </ProductManager>
                          </Frame1577>
                        </Frame1470>
                        <Frame1470>
                          <Frame1577>
                            <LastName>Last Name</LastName>
                            <Doe>{memberState?.last_name}</Doe>
                          </Frame1577>
                          <Frame1484_0001>
                            <Phone>Phone</Phone>
                            <_12209983347>
                              {memberState?.phone_number}
                            </_12209983347>
                          </Frame1484_0001>
                          {memberState?.member_type === "Enterprise" && (
                            <Frame1577>
                              <CompanyWebsite>Company Website</CompanyWebsite>
                              <GreenleafsolutionsCom>
                                {memberState?.company_website_url}
                              </GreenleafsolutionsCom>
                            </Frame1577>
                          )}
                          <Frame1577>
                            <SeniorityLevel>Seniority Level</SeniorityLevel>
                            <Senior>{memberState?.seniority}</Senior>
                          </Frame1577>
                        </Frame1470>
                      </Frame1485>
                      {memberState?.member_type === "Enterprise" && (
                        <Frame1479_0001>
                          <CompanyAddress>Company Address</CompanyAddress>
                          <_80NorthPromenadeDonningtonGl56BwUnitedKingdom>
                            {memberState?.company_address}
                          </_80NorthPromenadeDonningtonGl56BwUnitedKingdom>
                        </Frame1479_0001>
                      )}
                      <Frame1577>
                        <CountryOfResidence>
                          Country of Residence
                        </CountryOfResidence>
                        <UnitedKingdom>
                          {memberState?.country_of_residence}
                        </UnitedKingdom>
                      </Frame1577>
                    </Frame1510>
                  </Frame1508>

                  <Frame1470A>
                    <Frame1470>
                      <Frame1577>
                        <KYC>KYC</KYC>
                        <UnitedKingdom>Incomplete</UnitedKingdom>
                      </Frame1577>
                    </Frame1470>
                    <Frame1470>
                      <Frame1577>
                        <KYC>Bank Details</KYC>
                        <UnitedKingdom>
                          {memberState?.stripe_account_id ? "Complete" : "N/A"}
                        </UnitedKingdom>
                      </Frame1577>
                    </Frame1470>
                  </Frame1470A>
                </Frame1511>
              </Frame1469>
              <RecentReferrals>
                <Frame1433>
                  <Frame1431>
                    <SubmittedReferrals>Submitted Referrals</SubmittedReferrals>
                  </Frame1431>
                </Frame1433>

                <PRTNR.TableComponent
                  data={tableData}
                  tableColumn={tableColumns}
                  tableHeader={tableHeaders}
                  viewClick={handleClick}
                />
              </RecentReferrals>

              <RecentReferrals>
                <Frame1433>
                  <Frame1431>
                    <SubmittedReferrals>Friends Referred</SubmittedReferrals>
                  </Frame1431>
                </Frame1433>

                <PRTNR.TableComponent
                  data={list}
                  tableColumn={tableColumnsFriendsReferred}
                  tableHeader={tableHeadersFriendsReferred}
                />
              </RecentReferrals>

              <ActivityNotification>
                <Frame1433>
                  <History>History</History>
                </Frame1433>
                {history?.length > 0 &&
                  [...history].map((val, idx) => (
                    <>
                      <PRTNR.AccountHistory
                        status={val.action}
                        date={val.created_at}
                        changes={val?.changes}
                        key={idx}
                      />
                      <Seperator />
                    </>
                  ))}
              </ActivityNotification>
            </Right>
          )}
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalAdminmemberstwo
          isOpen={isModalOpen}
          onClose={closeModal}
          data={editMemberState}
          setData={setEditMemberState}
          setOldData={setMemberState}
          oldData={memberState}
        />
      </GenericModal>
      <GenericModal isOpen={isEditModalOpen} onClose={closeEditModal}>
        <ModalAdmineditmember
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          data={editMemberState}
          setData={setEditMemberState}
          setOldData={setMemberState}
          oldData={memberState}
          openSuccessModal={openSuccessModal}
        />
      </GenericModal>
      <GenericModal isOpen={isStatusModalOpen} onClose={closeStatusModal}>
        <ModalAdminmemberstatus
          isOpen={isStatusModalOpen}
          onClose={closeStatusModal}
          data={editMemberState}
          setData={setEditMemberState}
          setOldData={setMemberState}
          oldData={memberState}
        />
      </GenericModal>
      <GenericModal isOpen={isSuccessModalOpen} onClose={closeSuccessModal}>
        <ModalUpdateSuccess onClose={closeSuccessModal} />
      </GenericModal>
      <GenericModal
        isOpen={openPayoutModal}
        onClose={() => setOpenPayoutModal(false)}
      >
        <PayoutModal
          onClose={() => setOpenPayoutModal(false)}
          memberId={memberState?._id}
          balance={balance}
          memberType={memberState?.member_type}
        />
      </GenericModal>
    </RootWrapperAdminmemberstwo>
  );
}

const RootWrapperAdminmemberstwo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const Frame1577 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 683px;
  box-sizing: border-box;
`;

const LinkButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const GetStarted = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
  max-width: 500px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block; /* ensures ellipsis works properly */
`;

const Widthdraw = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const Frame1422 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 24px;
  flex-shrink: 0;
`;

const Frame1429 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: 1;
  box-sizing: border-box;
  width: 100%;
`;

const Status = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-width: 157px;
`;

const Enterprise = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1469 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1507 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ProfilePic = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 10px;
  border-radius: 500px;
  width: 142px;
  height: 137px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Frame1511 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  align-self: stretch;
  width: 672px;
  box-sizing: border-box;
  padding: 0px 16px;
  flex-shrink: 0;
`;

const Frame1484 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ProfileDetails = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 507px;
  min-height: 29px;
  flex: 1;
`;

const Frame1508 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1510 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1485 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: 16px;
`;

const Frame1470 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 370px;
  box-sizing: border-box;
`;
const Frame1470A = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-block: 1px solid #dbdbdb;
  padding-bottom: 24px;
  padding-top: 8px;
`;

const FirstName = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const James = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const JamesDoeEmailCom = styled.span`
  color: black;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;

  /* handle long words/emails gracefully */
  word-break: break-word; /* modern browsers */
  overflow-wrap: anywhere; /* allows breaking anywhere if needed */
`;

const CompanyName = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const GreenLeafSolutions = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const JobTitle = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const ProductManager = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const LastName = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Doe = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1484_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Phone = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const _12209983347 = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const CompanyWebsite = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const GreenleafsolutionsCom = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const SeniorityLevel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Senior = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1479_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const CompanyAddress = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const _80NorthPromenadeDonningtonGl56BwUnitedKingdom = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const CountryOfResidence = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
const KYC = styled.span`
  color: var(--Color-Text-Text, #212543);

  /* P2 */
  font-family: Montserrat;
  font-size: var(--Fonts-P2, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 28.8px */
`;

const UnitedKingdom = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const RecentReferrals = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1433 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 490px;
  box-sizing: border-box;
`;

const SubmittedReferrals = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const ActivityNotification = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const History = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 830px;
  min-height: 29px;
  flex: 1;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const BackText = styled.span`
  color: #64748b;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const ActiveText = styled.span`
  color: #6162c5;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
  margin-left: 12px;
`;

const Seperator = styled.div`
  height: 1px;
  background-color: rgba(136, 136, 136, 0.1);
  width: 100%;
`;
